module.exports = __webpack_public_path__ + "img/kinder_print.d8e44bbc.jpg";